import React from 'react'
import { KibButtonNew } from '@chewy/kib-controls-react'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'

export interface SuggestedActionButtonProps {
  disabled?: boolean
  onClick: () => void
  text: string
}

export const SuggestedActionButton: React.FC<SuggestedActionButtonProps> = ({
  text,
  onClick,
  disabled = false,
}) => (
  <KibButtonNew
    disabled={disabled}
    emphasis="tertiary"
    size="small"
    theme="utility"
    onClick={onClick}
  >
    {text}
  </KibButtonNew>
)

export default SuggestedActionButton
